import { Button, ErrorAlert } from '@/components';
import { useReferral } from '@/components/providers/postauth/ReferralProvider';
import { logDebug, logError, logInfo } from '@/utils/logger';
import { REFERRAL } from '@/utils/strings';
import React, { useEffect, useState } from 'react';
const COMPONENT_NAME = 'GenerateReferralCodeButton';
const GenerateReferralCodeButton: React.FC = () => {
  const { generateReferralCode, isLoading, error } = useReferral();
  const [showError, setShowError] = useState(false);
  useEffect(() => {
    if (error) {
      setShowError(true);
    }
  }, [error]);
  const handleClick = () => {
    logInfo('Generate button clicked', `${COMPONENT_NAME}.handleClick`);
    setShowError(false);
    try {
      logDebug('Calling generateReferralCode', `${COMPONENT_NAME}.handleClick`);
      generateReferralCode();
      logInfo(
        'generateReferralCode called successfully',
        `${COMPONENT_NAME}.handleClick`,
      );
    } catch (err) {
      logError(err, `${COMPONENT_NAME}.handleClick`);
    }
  };
  if (showError) {
    return (
      <div className="flex flex-col gap-4">
        <ErrorAlert
          title={REFERRAL.GENERATE_ERROR_TITLE}
          description={REFERRAL.GENERATE_ERROR_DESCRIPTION}
        />
        <Button type="button" onClick={() => setShowError(false)} fullWidth>
          {REFERRAL.TRY_AGAIN_BUTTON_TEXT}
        </Button>
      </div>
    );
  }
  return (
    <Button
      type="button"
      onClick={handleClick}
      fullWidth
      disabled={isLoading}
      loading={isLoading}
    >
      {REFERRAL.GENERATE_BUTTON_TEXT}
    </Button>
  );
};
export default GenerateReferralCodeButton;
